import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_REPAIR_AGENT } from '../../../../../webcomponents.constants';
import { translateFn } from '../../../../../utils/translator.helper';
import { NetworkPopUpEvents } from '../../NetworkBasePopUp';
import { FontSizes, LineHeights } from '../../../../../types/common/types';
import { styles } from './view/styles';

@customElement(WEB_COMPONENT_REPAIR_AGENT)
export class GzRepairAgentWebComponent extends LitElement {
  static get styles() {
    return styles;
  }

  protected render() {
    return html`
      <gz-text lineHeight="${LineHeights.NORMAL}" fontSize="${FontSizes.HEADING_6}"
        >${translateFn('To finish the repair task, an endpoint restart may be required.')}<br
      /></gz-text>
      <gz-text lineHeight="${LineHeights.NORMAL}" fontSize="${FontSizes.HEADING_6}">
        <br />
      </gz-text>
      <gz-text lineHeight="${LineHeights.NORMAL}" fontSize="${FontSizes.HEADING_6}"
        >${translateFn(
          'The repair task will reset the security agent to the version available on the slow ring or configured in the GravityZone console.'
        )}</gz-text
      >
      <div id="checkbox-content">
        <gz-checkbox
          @change="${this.handleCheckboxChanged}"
          label="${translateFn('I understand and agree')}"
        ></gz-checkbox>
      </div>
    `;
  }

  private handleCheckboxChanged(event: CustomEvent) {
    event.stopImmediatePropagation();
    const checked = event.detail.checked;
    this.dispatchEvent(new CustomEvent(NetworkPopUpEvents.SET_CONFIRM_BUTTON, { detail: { value: !checked } }));
  }
}
